// src/modules/app-views/fiscal-config/pages/Document/actions/dropdownMenu.js

import {
  PlusOutlined,
  CopyOutlined,
  InboxOutlined,
  DeleteOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import routeService from 'services/routeService';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownDuplicate,
  dropdownEdit,
  dropdownNew,
  dropdownReload,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';

const companiesDocumentDropdownMenu = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',
    // type: 'default',

    dropdownItems: [
      dropdownNew,
      // dropdownEdit,
      // dropdownReload,
      dropdownDuplicate,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,
    ],
  };
};

export default companiesDocumentDropdownMenu;
